import { useQuery, useQueryClient } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { getLinkedInAttribution } from '@/shared/lib/attribution';
import { User } from '@/shared/types/User';

import { LINKEDIN_ATTRIBUTION_QUERY_KEY } from '../lib/constants';
import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

export const useSyncLinkedInAttribution = (user?: User) => {
  const queryClient = useQueryClient();
  const userId = user?.id;

  useQuery({
    enabled: Boolean(userId),
    queryFn: async () => {
      if (!userId) return null;

      const attribution = getLinkedInAttribution();
      if (!attribution) return null;

      const current = queryClient.getQueryData<User>(USER_QUERY_KEYS.userData);
      if (!current || current.id !== userId || current.linkedin?.li_fat_id === attribution.li_fat_id) return null;

      const response = await API.saveLinkedInAttribution(attribution);
      queryClient.setQueryData<User>(USER_QUERY_KEYS.userData, (cachedUser) =>
        cachedUser?.id === userId ? { ...cachedUser, linkedin: response } : cachedUser,
      );

      return response;
    },
    queryKey: [...LINKEDIN_ATTRIBUTION_QUERY_KEY, userId],
    refetchInterval: 60_000,
    refetchOnWindowFocus: 'always',
    retry: false,
  });
};
